<template>
  <div>
    <a-row class="pl-2 pr-3">
      <a-col :span="15">
        <h2 class="text-bold">{{title}}</h2>
        <h5 style="line-height:20px" class="text-opacity">{{description}}</h5>
      </a-col>
      <a-col v-show="route && route !== undefined" :span="9">
        <router-link :to="route">
          <button
            class="btn btn-primary"
            style="float:right"
          >New {{title.substring(0, title.length - 1)}}</button>
        </router-link>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    description: String,
    route: Object
  }
};
</script>
